import { Tab, Tabs } from '@mui/material';
import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import HeaderItem from '../HeaderItem';

type Props = {
  selectedTab: number;
  onTabChange?: (tab: number) => void;
  tabs: Array<{
    label: string;
    icon?: ReactElement;
    click?: () => void;
  }>;
};

const HeaderTabs = (props: Props) => {
  const { selectedTab, onTabChange, tabs } = props;
  const { t } = useTranslation();

  return (
    <HeaderItem className="tabs-box">
      <Tabs
        className="tabs-container"
        value={selectedTab || selectedTab === 0 ? selectedTab : false}
        variant="fullWidth"
        indicatorColor="primary"
        textColor="secondary"
        onChange={(_, tab) => {
          tabs[tab]?.click?.();

          if (typeof onTabChange === 'function') {
            onTabChange(tab);
          }
        }}
      >
        {tabs.map((tab) => (
          <Tab key={'header-tab-' + tab.label} className="header-tab" icon={tab.icon} label={t(tab.label)} />
        ))}
      </Tabs>
    </HeaderItem>
  );
};

export default HeaderTabs;
